module.exports = __webpack_public_path__ + "img/info-dot.05b9ce1e.svg";